const isPathActive = (path, pathname, isAnchor) => {
  if (path) {
    return isAnchor ? pathname.startsWith(path) : path === pathname;
  }
  return false;
};

export default isPathActive;
